<template>
    <div class="ranking">
        <div class="ranking-container">
            <div class="title-ranking">
                <div class="title">
                    Ranking baseado no <span class="bold">saldo final</span>
                </div>
                <span class="second-title">(até agora)</span>
            </div>
            <div class="ranking-placing">
            <div class="placing-container">
                    <div class="scenario title-placements">
                        cenário
                    </div>
                    <div class="placing-body">
                        <div class="degrade-left"></div>
                        <div class="first-player extreme-placements">
                            <div class="titles-placements">
                                <span class="title-placements">Colocacão</span>
                                <span class="title-placements">Saldo</span>
                            </div>
                            <div class="info-placements">
                                <span class="placing-number info-placing">
                                    1º 
                                </span>  
                                <span class="placing-score info-placing">
                                    {{firstPlacement.score}}
                                </span>  
                            </div>
                        </div>
                        <div class="player-placement">
                            <div class="player-position" :style="{ 'transform' : `translateY(${heightCalc}px)`}">
                                <div class="player-pos">
                                    {{ userPlacement.position }}º
                                </div>
                                <div class="player-score">
                                    <img src="/img/icons/coin.png" class="coin-img">
                                    <span class="score">{{ userPlacement.score }}</span>
                                </div>
                            </div>
                            <div class="you" :style="{ 'transform' : `translateY(${heightCalc}px)`}">
                                <div class="you-container">
                                     <span>
                                        Você
                                    </span>
                                </div>
                               
                            </div>
                        </div>
                        <div class="last-player extreme-placements">
                            <div class="info-placements">
                                <span class="placing-number info-placing">
                                    {{lastPlacement.position}}º 
                                </span>
                                <span class="placing-score info-placing">
                                    {{lastPlacement.score}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            firstPlacement : {
                score : '49.100',
                position : 1
            },
            lastPlacement : {
                score : '13.200',
                position : 1350
            },
            userPlacement : {
                score : '36.000',
                position : 1000
            },
            heightCalc : 0
        }
    },
    mounted(){
        this.calcHeight()
    },
    methods: {
        calcHeight(){
            let self = this
            let rule3 = ''
            setTimeout(function(){ 
                let first = self.firstPlacement.position
                let last = self.lastPlacement.position
                let player = self.userPlacement.position
                let playerPlacement = document.querySelector('.player-placement').scrollHeight

                rule3 = ((player * (playerPlacement - (playerPlacement * 0.15))) / last )
                
                self.heightCalc = rule3.toFixed()
                return rule3
            }, 1000);
        }
    }
    
}
</script>
<style lang="scss" scoped>
    .ranking{

        height: 60vh;
        background-color: #dbfcfa;

        .title-placements{

            text-transform: uppercase;
            font-size: 0.5em;
            font-weight: bold;
            letter-spacing: 1px;
            color: #879b9c;
        }

        .ranking-container{

            width: 85%;
            margin: 0 auto;
            height: 100%;

            .title-ranking{

                text-align: center;
                width: 105%;
                margin: 0 auto;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                letter-spacing: 1px;
                text-transform: uppercase;


                .title{

                    font-size: 14px;
                    padding-top: 7%;
                }

                .second-title{

                    font-size: 12px;
                    margin-top: 2%;
                }
            }
        }

        .ranking-placing{

            width: 100%;
            height: 85%;
            margin-top: 2%;

            .placing-container{

                width: 95%;
                height: 100%;;
                margin: 0 auto;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .scenario{
                    width: 5%;
                    transform: rotate(270deg);
                    margin-top: 10%;
                }

                .placing-body{
                    width: 93%;
                    height: 85%;
                    border: 1px solid black;
                    background-image: repeating-linear-gradient(180deg,  #a3bcba, #a3bcba 1px, #b7d2d0 1px, #b7d2d0 10px);
                    display: flex;
                    flex-direction: column;
                    position: relative;

                    .degrade-left{

                        width: 30.5%;
                        height: 100%;
                        background: linear-gradient(180deg, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.05) 100%);
                        position: absolute;
                        z-index: 10;
                    }


                    .extreme-placements{

                        width: 100%;
                        height: 10%;
                        background-color: #91a7a5;
                        position: relative;

                        .titles-placements{

                            position: absolute;
                            top: -15px;
                            width: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;

                            .title-placements{

                                width: 30%;
                                text-align: center;
                            }
                        }

                        .info-placements{

                            width: 100%;
                            height: 100%;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;

                            .info-placing{

                                width: 30%;
                                height: 100%;
                                text-align: center;
                                color: white;
                                font-size: 1em;
                                z-index: 1000;
                                display: flex;
                                align-items: center;
                                justify-content: center;

                                &:first-child{

                                    border-right: 1px solid #4b5755;
                                    font-weight: bold;
                                }
                            }
                        }
                    }

                    .player-placement{

                        width: 100%;
                        height: 80%;
                        display: flex;
                        flex-direction: column;
                        position: relative;

                        .player-position{

                            height: 15%;
                            width: 100%;
                            background-color: #810080;
                            transition: transform 1s ease-out;
                            font-weight: bold;
                            display: flex;
                            color: white;

                            .player-pos{

                                width: 30%;
                                height: 100%;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                            }

                            .player-score{

                                width: 70%;
                                height: 100%;
                                display: flex;
                                align-items: center;
                                justify-content: flex-end;

                                .coin-img{
                                    width: 30px;
                                }

                                .score{

                                    font-size: 1.2em;
                                    margin: 0 10% 0 5%;

                                }
                            }
                        }
                    }

                    .you{

                        transition: transform 1s ease-out;
                        position: absolute;
                        right: -25px;
                        width: 25px;
                        height: 15%;
                        top: 0;
                        background-color: #6c006f;
                        display: flex;
                        align-items: center;
                        color: white;

                        .you-container{

                           transform: rotate(270deg); 

                           span{

                                font-size: 9px;
                                font-weight: bold;
                                text-transform: uppercase;
                           }
                        }
                    }
                }
            }
        }
    }

    @media only screen and (max-width : 350px){
        .ranking{

            .title-placements{

            }

            .ranking-container{

                .title-ranking{

                    .title{

                        font-size: 13px;
                    }

                    .second-title{

                        font-size: 9px;
                    }
                }
            }
        }
    }

    @media only screen and (min-width: 600px){
        .ranking{

            .ranking-container{

                .title-ranking{

                    .title{

                        font-size: 18px;
                        padding-top: 5%;
                    }

                    .second-title{

                        font-size: 13px;
                    }
                }

                .ranking-placing{

                    margin-top: 0%;

                    .placing-container{

                        .placing-body{

                            .degrade-left{

                                width: 20%;
                            }

                            .player-placement{

                                .player-position{

                                    .player-pos{

                                        width: 20%;
                                        font-size: 18px;
                                    }

                                    .player-score{

                                        width: 80%;

                                        .score{

                                            font-size: 1.4em;
                                            margin: 0 10% 0 2%;
                                        }

                                        .coin-img{

                                            width: 50px;
                                        }
                                    }
                                }

                                .you{

                                    .you-container{

                                        span{

                                            font-size: 11px;
                                        }
                                    }
                                }
                            }

                            .extreme-placements{

                                .titles-placements{

                                    top: -20px;

                                    .title-placements{

                                        width: 20%;
                                    }
                                }

                                .info-placements{

                                    .info-placing{

                                        width: 20%;
                                        font-size: 18px;

                                        span{

                                            font-size: 18px;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }   
            }
        }
    }
</style>

